import { Component, OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { UntypedFormBuilder, FormArray, Validators, UntypedFormGroup, FormControl, FormBuilder, UntypedFormArray, FormGroup } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import * as moment from 'moment';
import { SharedService } from '../../shared.service';
import { CitytownService } from '../../../modules/systemconfig/citytown/citytown.service';
import { DistrictService } from '../../../modules/systemconfig/district/district.service';
import { OrganizationService } from '../../../modules/systemconfig/organization/organization.service';
import { ClassesService } from '../../../modules/academics/classes/classes.service';
import { StudentsService } from '../../../modules/students/student/student.service'
import { RelationshipService } from '../../../modules/systemconfig/relationship/relationship.service';
import { ReligionService } from '../../../modules/systemconfig/religion/religion.service';
import { NationalityService } from '../../../modules/systemconfig/nationality/nationality.service';
import { MatTabGroup } from '@angular/material/tabs';
import { TranslateService } from '@ngx-translate/core';
import { CountryService } from 'src/app/modules/systemconfig/country/country.service';
import { StateService } from 'src/app/modules/systemconfig/state/state.service';
import { SchoolsettingsService } from 'src/app/modules/schoolsettings/schoolsettings.service';
import Swal from 'sweetalert2';




@Component({
  selector: 'app-temporary_reg_form',
  templateUrl: '../pages/temporary_regform.component.html',
  styleUrls: ['../css/image_view.css']
})

export class TemporaryAdmissionComponent implements OnInit, OnDestroy {

  @ViewChild('tabGroup') tabGroup: MatTabGroup;
  // isInputFocused: string = '';
  stuVISAName: any;
  selectedStuVISAFile: any;
  selectedStuVISAFileUrl: any;
  selectedStuPassFileUrl: any;
  selectedStuPassFile: Blob;
  stuPassName: any;
  selectedStuEmiFileUrl: any;
  selectedStuEmiFile: Blob;
  stuEmiName: any;
  selectedGuardEmiFileUrl: any;
  selectedGuardEmiFile: Blob;
  guardEmiName: any;
  selectedGuardPassFileUrl: any;
  selectedGuardPassFile: Blob;
  guardPassName: any;
  selectedGuardVISAFileUrl: any;
  selectedGuardVISAFile: Blob;
  guardVISAName: any;
  countryData: any;
  stateData: any;
  fileUploadTimer: any;
  progress = 0;
  isTab2Disabled: boolean = true;
  isTab3Disabled: boolean = true;
  isImgTabDisabled: boolean = true;
  isTab4Disabled: boolean = true;
  isTab5Disabled: boolean = true;
  public student_gender = ['Boy', 'Girl', 'Transgender'];
  // public existing_parent = false;
  // public existing_employee = false;
  // show_exiting_parent_search = true;
  // public existing_user_id: any;
  // public parents$: any;
  // public email_exists = false;
  // private student_master_id: any;
  // public reg_no_exists = false;
  public student_professions = ["Baby", "Student", "Employee", "Unemployment", "Other"];
  public mother_guardian_same_address = false;
  public father_guardian_same_address = false;
  


  // onInputFocus(inputId: string) {
  //   this.isInputFocused = inputId;
  // }

  // onInputBlur(inputId: string) {
  //   if (this.isInputFocused === inputId) {
  //     this.isInputFocused = '';
  //   }
  // }

  public removeSiblings(i) {
    this.siblings_info.removeAt(i);
  }
  public addSiblings() {
    this.siblings_info.push(this.getSiblingsForm());
  }
  get siblings_info() {
    return this.SiblingsForm.get('siblings') as FormArray;
  }
  private getSiblingsForm() {
    return this.fb.group({
      id: [''],
      name: [''],
      profession: [''],
      profession_info: ['']
    })
  }
  formatDate() {
    if (this.GuardianInfoForm.get('dob').value) {
      const date = moment(this.GuardianInfoForm.get('dob').value, 'DD/MM/YYYY').format('YYYY-MM-DD');
      this.GuardianInfoForm.patchValue({
        dob: date
      });
    }
    if (this.StudentInfoForm.get('dob').value) {
      const date = moment(this.StudentInfoForm.get('dob').value, 'DD/MM/YYYY').format('YYYY-MM-DD');
      this.StudentInfoForm.patchValue({
        dob: date
      });
    }
    if (this.FatherInfoForm.get('dob').value) {
      const date = moment(this.FatherInfoForm.get('dob').value, 'DD/MM/YYYY').format('YYYY-MM-DD');
      this.FatherInfoForm.patchValue({
        dob: date
      });
    }
    if (this.MotherInfoForm.get('dob').value) {
      const date = moment(this.MotherInfoForm.get('dob').value, 'DD/MM/YYYY').format('YYYY-MM-DD');
      this.MotherInfoForm.patchValue({
        dob: date
      });
    }
    if (this.GuardianPassportVisaForm.get('date_of_issue').value) {
      const date = moment(this.GuardianPassportVisaForm.get('date_of_issue').value, 'DD/MM/YYYY').format('YYYY-MM-DD');
      this.GuardianPassportVisaForm.patchValue({
        date_of_issue: date
      });
    }
    if (this.GuardianPassportVisaForm.get('date_of_expiry').value) {
      const date = moment(this.GuardianPassportVisaForm.get('date_of_expiry').value, 'DD/MM/YYYY').format('YYYY-MM-DD');
      this.GuardianPassportVisaForm.patchValue({
        date_of_expiry: date
      });
    }
    if (this.GuardianPassportVisaForm.get('emirates_id_expiry').value) {
      const date = moment(this.GuardianPassportVisaForm.get('emirates_id_expiry').value, 'DD/MM/YYYY').format('YYYY-MM-DD');
      this.GuardianPassportVisaForm.patchValue({
        emirates_id_expiry: date
      });
    }
    if (this.GuardianPassportVisaForm.get('visa_expiry').value) {
      const date = moment(this.GuardianPassportVisaForm.get('visa_expiry').value, 'DD/MM/YYYY').format('YYYY-MM-DD');
      this.GuardianPassportVisaForm.patchValue({
        visa_expiry: date
      });
    }
    if (this.StudentPassportVisaForm.get('date_of_issue').value) {
      const date = moment(this.StudentPassportVisaForm.get('date_of_issue').value, 'DD/MM/YYYY').format('YYYY-MM-DD');
      this.StudentPassportVisaForm.patchValue({
        date_of_issue: date
      });
    }
    if (this.StudentPassportVisaForm.get('date_of_expiry').value) {
      const date = moment(this.StudentPassportVisaForm.get('date_of_expiry').value, 'DD/MM/YYYY').format('YYYY-MM-DD');
      this.StudentPassportVisaForm.patchValue({
        date_of_expiry: date
      });
    }
    if (this.StudentPassportVisaForm.get('emirates_id_expiry').value) {
      const date = moment(this.StudentPassportVisaForm.get('emirates_id_expiry').value, 'DD/MM/YYYY').format('YYYY-MM-DD');
      this.StudentPassportVisaForm.patchValue({
        emirates_id_expiry: date
      });
    }
    if (this.StudentPassportVisaForm.get('visa_expiry').value) {
      const date = moment(this.StudentPassportVisaForm.get('visa_expiry').value, 'DD/MM/YYYY').format('YYYY-MM-DD');
      this.StudentPassportVisaForm.patchValue({
        visa_expiry: date
      });
    }
  }

  public GuardianInfoForm: UntypedFormGroup = this.fb.group({
    first_name: [''],
    middle_name: [''],
    last_name: [''],
    dob: [null],
    gender: [''],
    religion: [null],
    email: ['', [Validators.email]],
    nationality: [null],
    mobile_number: [''],
    age: [null],
    qualification: [''],
    occupation: [''],
    designation: [''],
    name_of_organization: [''],
    address_of_organization: [''],
    state: [null],
    office_number: [''],
    telephone_number: [''],
    relation: [null]
  })

  public GuardianAddressForm: UntypedFormGroup = this.fb.group({
    address: [''],
    country: [null],
    state: [null],
    district: [null],
    city: [null],
    zipcode: [''],
    l_address: [''],
    l_country: [null],
    l_state: [null],
    l_district: [null],
    l_city: [null],
    l_zipcode: [''],
  })

  public GuardianPassportVisaForm: UntypedFormGroup = this.fb.group({
    passport_number: [''],
    place_of_issue: [''],
    date_of_issue: [null],
    date_of_expiry: [null],
    emirates_id: [''],
    emirates_id_expiry: [null],
    visa_number: [''],
    visa_expiry: [null],
    passport_url: [null],
    emirates_id_url: [null],
    visa_url: [null],
  })
  public GrandParentInfoForm: UntypedFormGroup = this.fb.group({
    grand_father_name: [''],
    grand_father_qualification: [''],
    grand_mother_name: [''],
    grand_mother_qualification: ['']
  })

  get grand_parent_info() {
    return this.GrandParentInfoForm.controls;
  }
  get guardian_info() {
    return this.GuardianInfoForm.controls;
  }
  get guardian_address() {
    return this.GuardianAddressForm.controls;
  }
  selectedFile: File | null = null;
  selectedPassSizeFile: File | null = null;
  selectedFamFile: File | null = null;
  selectedStuFile: File | null = null;
  selectedFileUrl: string | null = null;
  selectedPassSizeFileUrl: string | null = null;
  selectedFamFileUrl: string | null = null;
  selectedStuFileUrl: string | null = null;

  enableNextTab() {
    if (this.tabGroup.selectedIndex === 0) {
      this.StudentInfoForm.markAllAsTouched();
      this.StudentOtherInfoForm.markAllAsTouched();
      if (this.StudentInfoForm.valid && this.StudentOtherInfoForm.valid) {
        this.isTab2Disabled = false;
        this.tabGroup.selectedIndex = 1;
      }
      else {
        Swal.fire({
          icon: 'error',
          text: this.translate.instant('Please fill out all the mandatory fields!'),
          confirmButtonText: 'Okay'
        })
      }
    }
    else if (this.tabGroup.selectedIndex === 1) {
      this.StudentPassportVisaForm.markAllAsTouched();
      this.StudentAddressForm.markAllAsTouched();
      if (this.StudentPassportVisaForm.valid && this.StudentAddressForm.valid) {
        this.isImgTabDisabled = false;
        this.tabGroup.selectedIndex = 2;
      }
      else {
        Swal.fire({
          icon: 'error',
          text: this.translate.instant('Please fill out all the mandatory fields!'),
          confirmButtonText: 'Okay'
        })
      }
    }
    else if (this.tabGroup.selectedIndex === 2) {
      this.GuardianImageForm.markAllAsTouched();

      if (this.GuardianImageForm.valid) {
        this.isTab3Disabled = false;
        this.tabGroup.selectedIndex = 3;
      }
      else {
        Swal.fire({
          icon: 'error',
          text: this.translate.instant('Please fill out all the mandatory fields!'),
          confirmButtonText: 'Okay'
        })
      }
    }
    else if (this.tabGroup.selectedIndex === 3) {
      this.GuardianInfoForm.markAllAsTouched();
      this.GuardianAddressForm.markAllAsTouched();
      this.GuardianPassportVisaForm.markAllAsTouched();
      if (this.GuardianInfoForm.valid && this.GuardianAddressForm.valid && this.GuardianPassportVisaForm.valid) {
        this.isTab4Disabled = false;
        this.tabGroup.selectedIndex = 4;
      }
      else {
        Swal.fire({
          icon: 'error',
          text: this.translate.instant('Please fill out all the mandatory fields!'),
          confirmButtonText: 'Okay'
        })
      }
    }
    else if (this.tabGroup.selectedIndex === 4) {
      this.FatherInfoForm.markAllAsTouched();
      this.MotherInfoForm.markAllAsTouched();
      if (this.FatherInfoForm.valid && this.MotherInfoForm.valid) {
        this.isTab5Disabled = false;
        this.tabGroup.selectedIndex = 5;
      }
    }
  }
  prevTab() {
    if (this.tabGroup.selectedIndex === 0) {
      this.router.navigate(['/select_class'])
    }
    if (this.tabGroup.selectedIndex === 1) {
      this.tabGroup.selectedIndex = 0;
    }
    if (this.tabGroup.selectedIndex === 2) {
      this.tabGroup.selectedIndex = 1;
    }
    if (this.tabGroup.selectedIndex === 3) {
      this.tabGroup.selectedIndex = 2;
    }
    if (this.tabGroup.selectedIndex === 4) {
      this.tabGroup.selectedIndex = 3;
    }
    if (this.tabGroup.selectedIndex === 5) {
      this.tabGroup.selectedIndex = 4;
    }
  }
  triggerFileInput() {
    document.getElementById('fileInput').click();
  }
  triggerPassSizeFileInput() {
    document.getElementById('passportSizeFileInput').click();
  }
  triggerFamFileInput() {
    document.getElementById('famFileInput').click();
  }
  triggerStuFileInput() {
    document.getElementById('stuFileInput').click();
  }
  triggerStuVISAFileInput() {
    document.getElementById('stu_visa_url').click();
  }
  triggerGuardVISAFileInput() {
    document.getElementById('visa_url').click();
  }
  triggerStuPassFileInput() {
    document.getElementById('stu_passport_url').click();
  }
  triggerGuardPassFileInput() {
    document.getElementById('passport_url').click();
  }
  triggerStuEmiFileInput() {
    document.getElementById('emirates_id_url').click();
  }
  triggerGuardEmiFileInput() {
    document.getElementById('guard_emirates_id_url').click();
  }

  onStuPassSelected(event: any, type) {
    if (event.target.files && event.target.files.length > 0) {
      // this.selectedStuPassFile = event.target.files[0];
      this.stuPassName = event.target.files[0].name;
      // this.readSelectedStuPassFile();
    }
  }
  onGuardEmiSelected(event: any) {
    if (event.target.files && event.target.files.length > 0) {
      // this.selectedGuardEmiFile = event.target.files[0];
      this.guardEmiName = event.target.files[0].name;
      // this.readSelectedGuardEmiFile();
    }
  }
  onGuardPassSelected(event: any) {
    if (event.target.files && event.target.files.length > 0) {
      // this.selectedGuardPassFile = event.target.files[0];
      this.guardPassName = event.target.files[0].name;
      // this.readSelectedGuardPassFile();
    }
  }
  onStuVISASelected(event: any) {
    if (event.target.files && event.target.files.length > 0) {
      // this.selectedStuVISAFile = event.target.files[0];
      this.stuVISAName = event.target.files[0].name;
      // this.readSelectedStuVISAFile();
    }
  }
  onStuEmiSelected(event: any) {
    if (event.target.files && event.target.files.length > 0) {
      // this.selectedStuEmiFile = event.target.files[0];
      this.stuEmiName = event.target.files[0].name;
      // this.readSelectedStuEmiFile();
    }
  }
  onGuardVISASelected(event: any) {
    if (event.target.files && event.target.files.length > 0) {
      // this.selectedGuardVISAFile = event.target.files[0];
      this.guardVISAName = event.target.files[0].name;
      // this.readSelectedGuardVISAFile();
    }
  }
  // readSelectedGuardVISAFile() {
  //   const reader = new FileReader();
  //   reader.onload = (event: any) => {
  //     this.selectedGuardVISAFileUrl = event.target.result;
  //   };
  //   reader.readAsDataURL(this.selectedGuardVISAFile as Blob);
  // }

  // readSelectedStuEmiFile() {
  //   const reader = new FileReader();
  //   reader.onload = (event: any) => {
  //     this.selectedStuEmiFileUrl = event.target.result;
  //   };
  //   reader.readAsDataURL(this.selectedStuEmiFile as Blob);
  // }

  // readSelectedStuVISAFile() {
  //   const reader = new FileReader();
  //   reader.onload = (event: any) => {
  //     this.selectedStuVISAFileUrl = event.target.result;
  //   };
  //   reader.readAsDataURL(this.selectedStuVISAFile as Blob);
  // }

  // readSelectedGuardPassFile() {
  //   const reader = new FileReader();
  //   reader.onload = (event: any) => {
  //     this.selectedGuardPassFileUrl = event.target.result;
  //   };
  //   reader.readAsDataURL(this.selectedGuardPassFile as Blob);
  // }

  // readSelectedStuPassFile() {
  //   const reader = new FileReader();
  //   reader.onload = (event: any) => {
  //     this.selectedStuPassFileUrl = event.target.result;
  //   };
  //   reader.readAsDataURL(this.selectedStuPassFile as Blob);
  // }
  // readSelectedGuardEmiFile() {
  //   const reader = new FileReader();
  //   reader.onload = (event: any) => {
  //     this.selectedGuardEmiFileUrl = event.target.result;
  //   };
  //   reader.readAsDataURL(this.selectedGuardEmiFile as Blob);
  // }
  public SiblingsForm: FormGroup = this.fb.group({
    siblings: this.fb.array([])
  })
  public prevSchoolForm: UntypedFormGroup = this.fb.group({
    school_name: [''],
    school_address: [''],
    school_change_reason: ['']
  })
  get prev_school_info() {
    return this.prevSchoolForm.controls;
  }
  public GuardianImageForm: UntypedFormGroup = this.fb.group({
    fam_photo: [''],
    guard_photo: [''],
    stu_photo: [''],
    passport_size_photo: ['']
  })
  get GuardianImage() {
    return this.GuardianImageForm.controls;
  }
  public StudentInfoForm: UntypedFormGroup = this.fb.group({
    id: [''],
    first_name: [''],
    middle_name: [''],
    last_name: [''],
    dob: [null],
    gender: [''],
    religion: [null],
    email: [''],
    nationality: [null],
    class: [null],
    age: [null],
    id_card_no: [''],
    id_card_name: [''],
  })
  public StudentOtherInfoForm: UntypedFormGroup = this.fb.group({
    blood_group: [''],
    country_of_birth: [null],
    place_of_birth: [''],
    identification_mark: [''],
    hobbies: [''],
    mother_tongue: [''],
    is_disability: [false],
    disability: [''],
    height: [null],
    weight: [null]
  });
  public student_form_photos = []
  public student_form_image_priview = {}
  public all_classes = [];

  onFileSelection(event, type) {
    let selectedFile = event.target.files[0]
    if (selectedFile.size >= 5200000) {
      this.toastr.error(this.translate.instant('File size must be less than 5 MB'));
      return;
    }
    let i = 0;
    for (let form_photo of this.student_form_photos) {
      if (form_photo["key"] == type) {
        this.student_form_photos.splice(i, 1);
      }
      i = i + 1;
    }
    let reader = new FileReader();
    reader.readAsDataURL(selectedFile);
    reader.onload = (event: any) => {
      this.student_form_image_priview[type] = event.target.result
    }
    this.student_form_photos.push({ "key": type, "value": selectedFile, filename: selectedFile.name })
  }
  // updatePhotoFiled(type, value) {
  //   if (type == "student_profile") {
  //     this.StudentInfoForm.patchValue({
  //       photo: value
  //     })
  //   } else if (type == "student_family_photo") {
  //     this.StudentInfoForm.patchValue({
  //       family_photo: value
  //     })
  //   }
  //   else if (type == "student_passport_size_photo") {
  //     this.StudentInfoForm.patchValue({
  //       upload_passport_size_photo: value
  //     })
  //   }
  //   else if (type == "student_passport") {
  //     this.StudentPassportVisaForm.patchValue({
  //       passport_url: value
  //     })
  //   }
  //   else if (type == "student_emirates_id") {
  //     this.StudentPassportVisaForm.patchValue({
  //       emirates_id_url: value
  //     })
  //   }
  //   else if (type == "student_visa") {
  //     this.StudentPassportVisaForm.patchValue({
  //       visa_url: value
  //     })
  //   }
  //   else if (type == "guardian_photo") {
  //     this.GuardianInfoForm.patchValue({
  //       guardian_photo: value
  //     })
  //   }
  //   else if (type == "parent_passport_size_photo") {
  //     this.GuardianInfoForm.patchValue({
  //       upload_passport_size_photo: value
  //     })
  //   }
  //   else if (type == "parent_passport") {
  //     this.GuardianPassportVisaForm.patchValue({
  //       upload_passport: value
  //     })
  //   }
  //   else if (type == "parent_emirates_id") {
  //     this.GuardianPassportVisaForm.patchValue({
  //       emirates_id_url: value
  //     })
  //   }
  //   else if (type == "parent_visa") {
  //     this.GuardianPassportVisaForm.patchValue({
  //       visa_url: value
  //     })
  //   }
  //   if (value == null) {
  //     this.student_form_image_priview[type] = null;
  //     // (<HTMLInputElement>document.getElementById(type)).value = "";
  //   }
  // }

  get student_info() {
    return this.StudentInfoForm.controls;
  }
  get student_other_info() {
    return this.StudentOtherInfoForm.controls;
  }
  public StudentAddressForm: UntypedFormGroup = this.fb.group({
    id: [''],
    address: [''],
    country: ['null'],
    state: ['null'],
    district: ['null'],
    city: ['null'],
    zipcode: [''],
    l_address: [''],
    l_country: ['null'],
    l_state: ['null'],
    l_district: ['null'],
    l_city: ['null'],
    l_zipcode: [''],
  });
  public FatherInfoForm: UntypedFormGroup = this.fb.group({
    name: [''],
    age: [null],
    mobile_number: [null],
    qualification: [''],
    occupation: [''],
    designation: [''],
    name_of_organization: [''],
    address_of_organization: [''],
    country: [null],
    office_number: [null],
    telephone_number: [null],
    email: ['', [Validators.email]],
    dob: [null],
    nationality: [null],
    religion: [null]
  })
  public MotherInfoForm: UntypedFormGroup = this.fb.group({
    name: [''],
    dob: [null],
    religion: [null],
    email: ['', [Validators.email]],
    nationality: [null],
    mobile_number: [null],
    age: [null],
    qualification: [''],
    occupation: [''],
    designation: [''],
    name_of_organization: [''],
    address_of_organization: [''],
    country: [null],
    office_number: [''],
    telephone_number: ['']
  })
  get father_info() {
    return this.FatherInfoForm.controls;
  }
  get student_address() {
    return this.StudentAddressForm.controls;
  }
  get mother_info() {
    return this.MotherInfoForm.controls;
  }
  public StudentPassportVisaForm: UntypedFormGroup = this.fb.group({
    passport_number: [''],
    place_of_issue: [''],
    date_of_issue: [null],
    date_of_expiry: [null],
    emirates_id: [''],
    emirates_id_expiry: [null],
    visa_number: [''],
    visa_expiry: [null],
    passport_url: [null],
    emirates_id_url: [null],
    visa_url: [null]
  })
  get student_passport_visa() {
    return this.StudentPassportVisaForm.controls;
  }
  public address_types = [
    { 'id': 'p', 'label': 'Permanent address' },
    { 'id': 'l', 'label': 'Local address' },
  ]
  firstFormGroup = this._formBuilder.group({
    firstCtrl: ['', Validators.required],
  });
  secondFormGroup = this._formBuilder.group({
    secondCtrl: ['', Validators.required],
  });
  isLinear = false;
  panelOpenState = false;

  RegistrationForm: UntypedFormGroup = this.fb.group({
    parent_image: [''],
    guardian_name: ['', Validators.required],
    guardian_mobile_no: ['', Validators.required],
    parent_email_id: [''],
    parent_contact_number: [''],
    parent_address: [''],
    parent_dob: [''],
    parent_relation_id: [''],
    parent_nationality_id: [''],
    parent_district: [''],
    parent_city: [''],
    parent_zipcode: [''],
    parent_state: [''],
    student_image: [''],
    student_fullname: [''],
    student_first_name: ['', Validators.required],
    student_middle_name: [''],
    student_last_name: [''],
    reg_no: [''],
    date_of_registration: ['', Validators.required],
    student_class: ['', Validators.required],
    student_division: ['', Validators.required],
    student_dob: ['', Validators.required],
    student_gender: ['', Validators.required],
    student_blood_group: [''],
    student_nationality_id: ['', Validators.required],
    place_of_birth: [''],
    place_of_birth_country: [''],
    student_religion_id: [''],
    identity_mark: [''],
    admission_date: [''],
    passport_number: [''],
    passport_expiry_date: ['', Validators.required],
    passport_date_of_issue: ['', Validators.required],
    passport_place_of_issue: [''],
    emirates_id_number: [''],
    emirates_expiry_date: ['', Validators.required],
    residence_visa_number: [''],
    residence_visa_expiry_date: [''],
    permanent_address: [''],
    permanent_address_district: [''],
    permanent_address_state: [''],
    permanent_address_city: [''],
    permanent_address_zipcode: [''],
    father_name: ['', Validators.required],
    father_educational_qualification: [''],
    father_occupation: [''],
    father_designation: [''],
    father_working_firm: [''],
    father_working_firm_address: [''],
    father_state_id: [''],
    father_office_no: [''],
    father_telephone_no: [''],
    father_email_id: ['', Validators.required],
    father_mobile_no: ['', Validators.required],
    mother_name: ['', Validators.required],
    mother_dob: [''],
    mother_educational_qualification: [''],
    mother_occupation: [''],
    mother_designation: [''],
    mother_working_firm: [''],
    mother_working_firm_address: [''],
    mother_state_id: [''],
    mother_office_no: [''],
    mother_telephone_no: [''],
    mother_mobile_no: ['', Validators.required],
    mother_email_id: [''],
    grand_father_name: [''],
    grand_mother_name: [''],
    grand_father_educational_qualification: [''],
    grand_mother_educational_qualification: [''],
    family_image: ['']
  });

  profilepic_size = 0
  errors: string;
  classData: any;
  divisionData: any;
  religionData: any;
  relationData: any;
  nationalityData: any;
  submitted: boolean = false;
  submit: any
  added: boolean = false;
  message: any;
  saveDisable: boolean = false;
  cities: any = [];
  districts: any = [];
  studentFile: File;
  parentFile: File;
  schoolname: any;
  schoolemail: any;
  schoolphone: any;
  schooladdress: any;
  schoollogo: any;
  schooladdressline: any;
  page_flag = 0
  school: any;
  genders: string[] = ['Male', 'Female', 'Other'];
  blood_groups: string[] = ['O-', 'O+', 'A-', 'A+', 'B-', 'B+', 'AB-', 'AB+'];
  public student_creation_settings: any;
  public page_list = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
  showPreview = false;

  constructor(
    private schoolsettingsService: SchoolsettingsService,
    private toastr: ToastrService,
    private fb: UntypedFormBuilder,
    private route: ActivatedRoute,
    private sharedService: SharedService,
    private router: Router,
    private studentsService: StudentsService,
    private districtservice: DistrictService,
    private citytownservice: CitytownService,
    private organizationservice: OrganizationService,
    private classesservice: ClassesService,
    private relationshipService: RelationshipService,
    private religionService: ReligionService,
    private nationalityService: NationalityService,
    private _formBuilder: FormBuilder,
    public translate: TranslateService,
    public countryService: CountryService,
    public stateService: StateService
  ) {
  }

  get f() {
    return this.RegistrationForm.controls;
  }
  form_photos = [];
  images_upload_length = 0;
  image_upload_progress = 0;
  images_fileUploadTimer: any;
  async uploadFiles(id, msg, status, application_no) {
    this.images_upload_length = this.student_form_photos.length;
    // if (this.images_upload_length > 0) {
    //   // this.toastr.info(this.translate.instant('Image upload in progress!'));
    //   Swal.fire({
    //     icon: 'success',
    //     title: 'Your application status!',
    //     html: msg + '<br>Your Application Number is "' + application_no + '". Please save your application number.',
    //     confirmButtonText: 'Okay'
    //   }).then((result) => {
    //     if (result.isConfirmed) {
    //       this.router.navigate(['/register_form']);
    //     }
    //   });
    // } 
    // else {
    //   Swal.fire({
    //     icon: 'success',
    //     title: 'Your application status!',
    //     html: msg + '<br>Your Application Number is "' + application_no + '". Please save your application number.',
    //     confirmButtonText: 'Okay'
    //   }).then((result) => {
    //     if (result.isConfirmed) {
    //       this.router.navigate(['/register_form']);
    //     }
    //   });
    // }
    if (this.images_upload_length > 0) {
      const that = this;
      for (let index = 0; index < this.student_form_photos.length; index++) {
        var uploadData = new FormData();
        uploadData.append('id', id);
        uploadData.append('key', this.student_form_photos[index]['key']);
        uploadData.append('file', this.student_form_photos[index]['value']);
        let response = await this.sharedService.submitTemporaryRegistrationImages(uploadData).toPromise().catch((error) => {
          this.progress = this.progress + 1;
          this.toastr.error(this.translate.instant(error['error']));
        });
        if (response == 'success') {
          this.toastr.info(this.student_form_photos[index]['filename'] + this.translate.instant(' Uploaded Successfully.'));
          this.progress = this.progress + 1;
          if(this.progress == this.images_upload_length){
            Swal.fire({
                icon: 'success',
                title: 'Your application status!',
                html: msg + '<br>Your Application Number is "' + application_no + '". Please save your application number.',
                confirmButtonText: 'Okay'
              }).then((result) => {
                if (result.isConfirmed) {
                  this.router.navigate(['/register_form']);
                }
              });
          }
        }
      }
      
      // this.fileUploadTimer = setInterval(function () {
      //   if (that.progress === that.images_upload_length) {
      //     // Swal.fire({
      //     //   icon: 'success',
      //     //   title: 'Your application status!',
      //     //   html: msg + '<br>Your Application Number is "' + application_no + '". Please save your application number.',
      //     //   confirmButtonText: 'Okay'
      //     // }).then((result) => {
      //     //   if (result.isConfirmed) {
      //     //     this.router.navigate(['/register_form']);
      //     //   }
      //     // });
      //     // Swal.fire({
      //     //     icon: 'success',
      //     //     title: 'Your application status!',
      //     //     text: 'Your application has submitted successfully',
      //     //     confirmButtonText: 'Okay'
      //     // })
      //     // that.toastr.success(this.translate.instant('Saved Succesfully!'));
      //     // that.router.navigate(['/register_form'])
      //   }
      // }, 1000);
    }
    else{
      Swal.fire({
            icon: 'success',
            title: 'Your application status!',
            html: msg + '<br>Your Application Number is "' + application_no + '". Please save your application number.',
            confirmButtonText: 'Okay'
          }).then((result) => {
            if (result.isConfirmed) {
              this.router.navigate(['/register_form']);
            }
          });
    }
  }

  confirmation_flag = false;
  copyGuardianInfo(type) {
    if (type == 'father') {
      if(!this.father_guardian_same_address){
      this.FatherInfoForm.patchValue({
        name: this.GuardianInfoForm.value['first_name'] + ' ' + this.GuardianInfoForm.value['middle_name'] + ' ' + this.GuardianInfoForm.value['last_name'],
        // age: [null],
        mobile_number: this.GuardianInfoForm.value['mobile_number'],
        qualification: this.GuardianInfoForm.value['qualification'],
        // occupation: this.GuardianInfoForm.value['occupation'],
        designation: this.GuardianInfoForm.value['designation'],
        name_of_organization: this.GuardianInfoForm.value['name_of_organization'],
        address_of_organization: this.GuardianInfoForm.value['address_of_organization'],
        // country: [''],
        office_number: this.GuardianInfoForm.value['office_number'],
        telephone_number: this.GuardianInfoForm.value['telephone_number'],
        email: this.GuardianInfoForm.value['email'],
        dob: this.GuardianInfoForm.value['dob'],
        nationality: this.GuardianInfoForm.value['nationality'],
        religion: this.GuardianInfoForm.value['religion']
      });
      this.father_guardian_same_address = true;
    }
    else{
      this.FatherInfoForm.patchValue({
        name: [''],
        // age: [null],
        mobile_number: [''],
        qualification: [''],
        // occupation: [''],
        designation: [''],
        name_of_organization: [''],
        address_of_organization: [''],
        // country: [''],
        office_number: [''],
        telephone_number: [''],
        email: [''],
        dob: [''],
        nationality: [''],
        religion: ['']
      });
      this.father_guardian_same_address = false;
    }
    }
    if (type == 'mother') {
      if(!this.mother_guardian_same_address){
      this.MotherInfoForm.patchValue({
        name: this.GuardianInfoForm.value['first_name'] + ' ' + this.GuardianInfoForm.value['middle_name'] + ' ' + this.GuardianInfoForm.value['last_name'],
        // age: [null],
        mobile_number: this.GuardianInfoForm.value['mobile_number'],
        qualification: this.GuardianInfoForm.value['qualification'],
        // occupation: this.GuardianInfoForm.value['occupation'],
        designation: this.GuardianInfoForm.value['designation'],
        name_of_organization: this.GuardianInfoForm.value['name_of_organization'],
        address_of_organization: this.GuardianInfoForm.value['address_of_organization'],
        // country: [''],
        office_number: this.GuardianInfoForm.value['office_number'],
        telephone_number: this.GuardianInfoForm.value['telephone_number'],
        email: this.GuardianInfoForm.value['email'],
        dob: this.GuardianInfoForm.value['dob'],
        nationality: this.GuardianInfoForm.value['nationality'],
        religion: this.GuardianInfoForm.value['religion']
      });
      this.mother_guardian_same_address = true;
    }
    else{
      this.MotherInfoForm.patchValue({
        name: [''],
        // age: [null],
        mobile_number: [''],
        qualification: [''],
        // occupation: [''],
        designation: [''],
        name_of_organization: [''],
        address_of_organization: [''],
        // country: [''],
        office_number: [''],
        telephone_number: [''],
        email: [''],
        dob: [''],
        nationality: [''],
        religion: ['']
      });
      this.mother_guardian_same_address = false;
    }
    }
  }
  conFirmUpdate() {
    if (this.form_photos?.length == this.image_upload_progress && !this.confirmation_flag) {
      this.confirmation_flag = true;
      this.toastr.success(this.translate.instant('Saved Succesfully!'));
    }
  }
  editClicked() {
    // console.log("Student Info=======>"+JSON.stringify(this.StudentInfoForm.value));
    this.showPreview = false;
  }
  onPreview() {
    // console.log("Siblings form length========>"+this.SiblingsForm)
    this.GrandParentInfoForm.markAllAsTouched();
    this.SiblingsForm.markAllAsTouched();
    this.prevSchoolForm.markAllAsTouched();
    if (this.GrandParentInfoForm.valid && this.SiblingsForm.valid && this.prevSchoolForm.valid) {
      // this.formatDate();
      this.showPreview = true;
    }
    else {
      Swal.fire({
        icon: 'error',
        text: this.translate.instant('Please fill out all the mandatory fields!'),
        confirmButtonText: 'Okay'
      })
    }
  }
  onSubmit() {
    this.formatDate();
    this.sharedService.submitTemporaryRegistration({ "student_info_form": this.StudentInfoForm.value, "student_other_info_form": this.StudentOtherInfoForm.value, "student_address_form": this.StudentAddressForm.value, "student_passport_form": this.StudentPassportVisaForm.value, "guardian_info_form": this.GuardianInfoForm.value, "guardian_address_form": this.GuardianAddressForm.value, "guardian_passport_form": this.GuardianPassportVisaForm.value, "father_info_form": this.FatherInfoForm.value, "mother_info_form": this.MotherInfoForm.value, "grandparent_info_form": this.GrandParentInfoForm.value, "student_prev_school_info_form": this.prevSchoolForm.value, "student_sibling_info_form": this.SiblingsForm.value }).subscribe((data) => {
      this.uploadFiles(data['id'], data['message'], data['status'], data['application_no']);
    });
  }
  ngOnInit() {
    this.route.queryParamMap.subscribe(params => {
      const class_name = params.get('class');
      this.StudentInfoForm.patchValue({
        class: class_name
      })
    });
    this.schoolsettingsService.getStudentCreationSettings({ student_page_list: this.page_list }).subscribe(response => {
      this.student_creation_settings = response;
    })
    this.getschoolname();
    this.getClasses();
    this.getDivisions();
    this.getDistrict();
    this.getCity();
    this.getReligions();
    this.getRelationships();
    this.getNAtionalities();
    this.getCountries();
    this.getStates();

  }
  onStudentImgChanged(event) {
    this.studentFile = event.target.files[0];
  }

  onParentImgChanged(event) {
    this.parentFile = event.target.files[0];
  }

  getClasses() {
    this.classesservice.getdistinctclasses().subscribe(data => {
      this.classData = data;
    });
  }

  getDivisions() {
    this.classesservice.getdivisions(this.RegistrationForm.value.student_class).subscribe(data => {
      this.divisionData = data;
    });
  }

  getReligions() {
    this.religionService.getReligions().subscribe((data: any) => {
      this.religionData = data;
    });
  }

  getRelationships() {
    this.relationshipService.getRelationships().subscribe((data: any) => {
      this.relationData = data;
    });
  }

  getNAtionalities() {
    this.nationalityService.getNationalities().subscribe((data: any) => {
      this.nationalityData = data;
    });
  }
  getCountries() {
    this.countryService.getCountries().subscribe((data: any) => {
      this.countryData = data;
    });
  }
  getStates() {
    this.stateService.getStates().subscribe((data: any) => {
      this.stateData = data;
    });
  }

  ngOnDestroy(): void {
    clearInterval(this.fileUploadTimer);
  }

  checkEmailorContactNumberExist() {
    if (this.RegistrationForm.value.parent_contact_number && this.RegistrationForm.value.parent_email_id) {
      this.sharedService.checkEmailorContactNumberExist(this.RegistrationForm.value.parent_contact_number, this.RegistrationForm.value.parent_email_id).subscribe(data => {
        if (data['status'] == 1) {
          this.message = data['message'];
          if (this.message) {
            this.saveDisable = true;
          } else {
            this.saveDisable = false;
          }
        }
      });
    }
  }

  public getDistrict() {
    this.districtservice.getDistricts().subscribe((data: any) => {
      this.districts = data;
    });
  }

  public getCity() {
    this.citytownservice.getCitytowns().subscribe((data: any) => {
      this.cities = data;
    });
  }


  public getschoolname() {
    this.organizationservice.getactiveorganization().subscribe((data: any) => {
      this.school = data[0];
      this.schoolname = this.school['org_name']
      this.schoolemail = this.school['org_email']
      this.schoolphone = this.school['org_phone']
      this.schooladdress = this.school['org_address_line1']
      this.schooladdressline = this.school['org_address_line2']
      this.schoollogo = this.school['institute_image']

    });
  }

  Nextpagefn() {
    this.page_flag += 1
  }

  Prevpagefn() {
    this.page_flag -= 1
  }

  firstNextfn() {
    if (!this.RegistrationForm.value.student_fullname ||
      !this.RegistrationForm.value.student_class ||
      !this.RegistrationForm.value.student_division) {
      this.RegistrationForm.markAllAsTouched();
      this.toastr.error('Error!..', 'Please fill Name, Class and Class division..!');
    }
    else {
      this.page_flag += 1
    }
  }

  thirdNextfn() {
    if (!this.RegistrationForm.value.student_first_name ||
      !this.RegistrationForm.value.date_of_registration ||
      !this.RegistrationForm.value.student_nationality_id ||
      !this.RegistrationForm.value.student_gender ||
      !this.RegistrationForm.value.student_dob ||
      !this.RegistrationForm.value.passport_date_of_issue ||
      !this.RegistrationForm.value.passport_expiry_date ||
      !this.RegistrationForm.value.emirates_expiry_date ||
      !this.RegistrationForm.value.residence_visa_expiry_date) {
      this.RegistrationForm.markAllAsTouched();
      this.toastr.error('Error!..', 'Please fill all mandatory fields..!');
    }
    else {
      this.page_flag += 1
    }
  }

  fourthNextfn() {
    if (!this.RegistrationForm.value.father_name ||
      !this.RegistrationForm.value.father_email_id ||
      !this.RegistrationForm.value.father_mobile_no ||
      !this.RegistrationForm.value.mother_name ||
      !this.RegistrationForm.value.mother_mobile_no) {
      this.RegistrationForm.markAllAsTouched();
      this.toastr.error('Error!..', 'Please fill all mandatory fields..!');
    }
    else {
      this.page_flag += 1
    }
  }
}
